module.exports = __webpack_public_path__ + "img/ball-light.350637bc.svg";